<template>
  <!-- 基本描述、签证属性（有效期限、最长停留）、名词释义、办理方式（办理流程、所需资料、办理费用）、开放口岸、注意事项 -->
  <div class="strategy-form arrival-form">

    <div class="common-card">
      <!-- 基本描述 -->
      <div class="visa-basic">
        {{ info.basic_desc }}
      </div>

      <!--签证属性（有效期限、最长停留） -->
      <div class="visa-attr">
        <div class="common-visa-title none-border">签证属性</div>
        <div class="common-content">
          <strategy-table :list="visaAttrList"></strategy-table>
        </div>
      </div>
    </div>


    <!-- 名词释义 -->
    <div class="common-card visa-noun-explain" v-if="info.noun_explanation_list && info.noun_explanation_list.length">
      <div class="common-visa-title none-border">名词释义</div>
      <div class="common-content">
        <strategy-table :list="info.noun_explanation_list"></strategy-table>
      </div>
    </div>

    <!-- 办理方式（办理流程、所需资料、办理费用） -->
    <div class="common-card visa-flow" v-if="wayList && wayList.length">
      <div class="common-visa-title">办理方式</div>
      <div class="p-b-content">
        <strategy-step :step-content="wayList"></strategy-step>
      </div>
    </div>

    <!-- 开放口岸 -->
    <div class="common-card visa-open" v-if="info.open_port">
      <div class="common-visa-title">开放口岸</div>
      <div class="p-b-content">
        <strategy-step :step-content="info.open_port"></strategy-step>
      </div>
    </div>

    <!-- 注意事项 -->
    <div class="common-card visa-attention" v-if="info.attention">
      <strategy-attention :attention="info.attention"></strategy-attention>
    </div>

  </div>
</template>

<script>
import strategyAttention from '../strategy-form-item/strategy-attention.vue';
import strategyStep from '../strategy-form-item/strategy-step.vue';
import strategyTable from '../strategy-form-item/strategy-table.vue';
import countryVisaStrategyService from '../../../services/country-visa-strategy-service';


export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  components: {
    strategyTable,
    strategyStep,
    strategyAttention,
  },
  data() {
    return {};
  },
  computed: {
    visaAttrList() {
      const { visa_attr } = this.info || {};
      return countryVisaStrategyService.getVisaAttr(visa_attr);
    },
    wayList() {
      const { handle_way } = this.info || {};
      return countryVisaStrategyService.getHandleWay(handle_way);
    },
  },
};
</script>


<style lang="less" scoped>
@import "./common.less";
</style>


// WEBPACK FOOTER //
// src/pages/country/country-visa-strategy/components/strategy-visa-type-form/arrival-form.vue